import { pushEvent } from "./utils";
import { GTM_SUCCESS, GTM_ERROR } from "../utilities/constants";

/**
 * inits the messages data layer events
 */
const initDataLayerEvents = () => {
    document.addEventListener("dataLayer.messagesEvents", data => {
        const eventData = data?.detail;
        const messageDetails = {
            "messageType": eventData && eventData.success ? GTM_SUCCESS : GTM_ERROR,
            "messageContent": eventData && eventData.messageContent ? eventData.messageContent.toString() : "",
            "messageUrl": window.location.href
        };
        pushEvent("message", messageDetails);
    });
};

module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
